import React from "react"
import { render } from "react-dom"
import { BrowserRouter as Router, Route } from "react-router-dom"
import Provider from "../utils/connected-apollo-provider"

import Navigation from "../components/navigation"

render(
  <Provider>
    {/* Note: Forced refresh needed for Rails app until all of routing has move to SPA model */}
    <Router forceRefresh={true}>
      <Route path="/:appPrefix?/plans/:planName/:planCategory?">
        <Navigation
          showFacultyLink={document.body.dataset.facultyLinkEnabled ? true : false}
          currentRailsPath={document.body.dataset.currentRailsPath}
        />
      </Route>
    </Router>
  </Provider>,
  document.querySelector("#nav")
)
